// import Colors from '../../../../Configs/colors';

const styles = {
  root: {
  },
};

export default styles;
